import {create} from 'zustand';

/**
 * Zustand store for managing ChatFINTEL navigation state
 * Syncs chatId, and sourceSegmentId across components
 */
const usePolicyPageStore = create((set) => ({
    // State
    chatId: null,
    sourceSegmentId: null,

    // Actions
    setChatId: (chatId) => set({chatId}),
    setSourceSegmentId: (sourceSegmentId) => set({sourceSegmentId}),

    // Set all params at once (useful for initial sync from router)
    setParams: (params) => set({
        chatId: params.chatId ?? null,
        sourceSegmentId: params.sourceSegmentId ?? null,
    }),

    // Reset all params
    reset: () => set({
        chatId: null,
        sourceSegmentId: null,
    }),
}));

export default usePolicyPageStore;

